<section class="col-md-12">
    <ngb-pagination [collectionSize]="paginationInformation.totalCount" [(page)]="paginationInformation.currentPage"
        [maxSize]="5" [pageSize]="paginationInformation.itemsPerPage" [rotate]="true" [boundaryLinks]="true"
        (pageChange)="changePage($event)">
        <ng-template ngbPaginationFirst>{{'First' | translate}}</ng-template>
        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
                [class]="'font-weight-bolder'"></span>{{'Prev' | translate}}
        </ng-template>
        <ng-template ngbPaginationNext>{{'Next' | translate}}<span [data-feather]="'chevron-right'"
                [class]="'font-weight-bolder'"></span>
        </ng-template>
        <ng-template ngbPaginationLast>{{'Last' | translate}}</ng-template>
    </ngb-pagination>
</section>